import { IconMinus, IconPlusCircle } from 'assets/images'
import {
  InputCollapsableContainer,
  InputGroup
} from 'components/form-fields/styled'
import { useFormikContext } from 'formik'
import { t } from 'i18n'
import { RowItem } from 'pages/Report/components/form-components/styled'
import React, { useState } from 'react'
import { AssumedInjuryV2, Report } from 'store/ducks/report/types'
import BodyMapOverlay from './BodyMapOverlay'
import InjuryModal from './InjuryModal'
import { InjuryTitle } from './InjuryTitle'

export const InjuryDataV2: React.FC = () => {
  const {
    values: { injuryDataV2 },
    setFieldValue
  } = useFormikContext<Report>()
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [modalMode, setModalMode] = useState<'add' | 'edit'>('add')
  const [editingInjury, setEditingInjury] = useState<AssumedInjuryV2 | null>(
    null
  )
  const [editingIndex, setEditingIndex] = useState<number | null>(null)

  const handleSaveNew = (injury: AssumedInjuryV2) => {
    const currentInjuries = injuryDataV2?.assumedInjuries || []
    setFieldValue('injuryDataV2.assumedInjuries', [...currentInjuries, injury])
  }

  const handleRemove = (index: number) => {
    const current = injuryDataV2?.assumedInjuries || []
    const next = current.filter((_, i) => i !== index)
    setFieldValue('injuryDataV2.assumedInjuries', next)
  }

  const openEditModal = (injury: AssumedInjuryV2, index: number) => {
    setEditingInjury(injury)
    setEditingIndex(index)
    setModalMode('edit')
    setModalOpen(true)
  }

  const openAddModal = () => {
    setEditingInjury(null)
    setEditingIndex(null)
    setModalMode('add')
    setModalOpen(true)
  }

  const handleSave = (updatedInjury: AssumedInjuryV2) => {
    if (modalMode === 'add') {
      handleSaveNew(updatedInjury)
    } else if (editingIndex !== null) {
      const current = injuryDataV2?.assumedInjuries || []
      const next = current.map((item, i) =>
        i === editingIndex ? updatedInjury : item
      )
      setFieldValue('injuryDataV2.assumedInjuries', next)
    }
  }

  const closeModal = () => {
    setModalOpen(false)
    setEditingInjury(null)
    setEditingIndex(null)
  }

  return (
    <div className="injury-data-v2">
      <BodyMapOverlay
        injuries={injuryDataV2?.assumedInjuries || []}
        style={{ marginTop: '20px' }}
      />

      <div className="injuries-container">
        <RowItem width={20}>
          {injuryDataV2?.assumedInjuries?.map((injury, index) => {
            return (
              <div key={index}>
                <InputGroup>
                  <InputCollapsableContainer
                    onClick={() => openEditModal(injury, index)}
                    active={false}
                  >
                    <InjuryTitle injury={injury} />
                    <IconMinus
                      onClick={(e: any) => {
                        e.stopPropagation()
                        handleRemove(index)
                      }}
                    />
                  </InputCollapsableContainer>
                </InputGroup>
              </div>
            )
          })}
        </RowItem>

        {/* Add new injury button */}
        <RowItem width={20}>
          <InputGroup>
            <InputCollapsableContainer active={false} onClick={openAddModal}>
              <p>{t('newInjury')}</p>
              <IconPlusCircle />
            </InputCollapsableContainer>
          </InputGroup>
        </RowItem>
      </div>

      <InjuryModal
        open={modalOpen}
        mode={modalMode}
        initialInjury={editingInjury || undefined}
        onClose={closeModal}
        onSave={handleSave}
      />
    </div>
  )
}
